import { DeleteAgendaSlotApiResponse } from '@omecare/utils';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';

const deleteAgendaSlot = (id: string) => {
  return http.agendaSlots.deleteById(id);
};

const useDeleteAgendaSlotMutation = (): UseMutationResult<
  DeleteAgendaSlotApiResponse,
  Error,
  string
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: deleteAgendaSlot,
    onSuccess() {
      toast.success(t('http.delete-agenda-slot.success'));
    },
  });
};

export default useDeleteAgendaSlotMutation;
